import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { ConnectedRouter } from 'connected-react-router'
import './i18n';
import configureStore, { history } from './shared/state/configureStore';
import * as serviceWorker from './service-worker';
import 'semantic-ui-css/semantic.min.css';
import routes from './routes';
import GlobalStyles from "./styles";

ReactDOM.render(
  <Suspense fallback={null}>
    <Provider store={configureStore()}>
      <ConnectedRouter history={history}>
        <GlobalStyles/>
          {renderRoutes(routes)}
      </ConnectedRouter>
    </Provider>
  </Suspense>,
  document.getElementById('root')
);

serviceWorker.unregister();
